import styled, { css } from "styled-components";
import BaseInputLike from "../InputLike";

export const InputLike = styled(BaseInputLike)`
    ${({ disabled }) => !disabled && "cursor: pointer;"}
`;

export const DropdownWrapper = styled.div<{ $inPortal?: boolean }>`
    ${({ $inPortal }) =>
        !$inPortal &&
        css`
            top: calc(100% + 8px);
        `}
    left: 0;
    position: absolute;
    max-height: 260px;
    overflow-y: scroll;
    z-index: 3;
    width: -webkit-fill-available;
    width: -moz-available;
    display: flex;
    flex-direction: column;
    padding: 4px 0px 8px 0px;

    ${({ theme }) => css`
        color: ${theme.v2.colors["text-primary-1200"]};
        background-color: ${theme.v2.colors["background-primary-base"]};
        border-radius: 4px;
        box-shadow: 0 1px 5px ${theme.v2.colors["border-primary-200"]};
    `}
`;

export const ArrowWrapper = styled.div<{ withClearButton?: boolean }>`
    display: flex;
    position: absolute;
    right: 12px;
    color: ${({ theme, withClearButton }) =>
        theme.v2.colors[withClearButton ? "text-primary-300" : "text-primary-800"]};
`;

export const SelectWrapper = styled.div`
    position: relative;
`;

export const DropdownContent = styled.div`
    min-height: 20px;
    flex: 1;
`;
